
/**
 * Load required plugin.
 */
window.Typewriter = require('typewriter-effect/dist/core');

/**
 * Configure the plugin.
 */

+function($){
  page.registerVendor('Typewriter');

  page.initTypewriter = function() {
    $('.typewriter').each(function(i,v){
        var strings = $(v).data('typing').split(',');
        var id = $(v).attr('id');
        if(id) {
            id = '#'+id;
        }else{
            var id = Math.random().toString(36).substring(2,12);
            $(v).attr('id', id);
            id = '#'+id;
        }
        var options = {
            strings: strings,
            delay: 30,
            autoStart: true,
            loop: true
        };
        new Typewriter(id, options); 
    });

  } 

}(jQuery);
